export default {"src":"https://fishbrain.com/_next/static/media/oregon.811f1c19.svg","height":128,"width":128,"blurWidth":0,"blurHeight":0};